/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseOfString } from '../models/api-response-of-string';
import { Category } from '../models/category';
import { DataPageOfNotesTemplate } from '../models/data-page-of-notes-template';
import { Note } from '../models/note';
import { NotesTemplate } from '../models/notes-template';
import { notesTemplateAddPatientNotes } from '../fn/notes-template/notes-template-add-patient-notes';
import { NotesTemplateAddPatientNotes$Params } from '../fn/notes-template/notes-template-add-patient-notes';
import { notesTemplateCreatePdf } from '../fn/notes-template/notes-template-create-pdf';
import { NotesTemplateCreatePdf$Params } from '../fn/notes-template/notes-template-create-pdf';
import { notesTemplateDelete } from '../fn/notes-template/notes-template-delete';
import { NotesTemplateDelete$Params } from '../fn/notes-template/notes-template-delete';
import { notesTemplateFindAll } from '../fn/notes-template/notes-template-find-all';
import { NotesTemplateFindAll$Params } from '../fn/notes-template/notes-template-find-all';
import { notesTemplateFindNotesByCategory } from '../fn/notes-template/notes-template-find-notes-by-category';
import { NotesTemplateFindNotesByCategory$Params } from '../fn/notes-template/notes-template-find-notes-by-category';
import { notesTemplateFindTemplatesByCategory } from '../fn/notes-template/notes-template-find-templates-by-category';
import { NotesTemplateFindTemplatesByCategory$Params } from '../fn/notes-template/notes-template-find-templates-by-category';
import { notesTemplateGet } from '../fn/notes-template/notes-template-get';
import { NotesTemplateGet$Params } from '../fn/notes-template/notes-template-get';
import { notesTemplateGetAllcategories } from '../fn/notes-template/notes-template-get-allcategories';
import { NotesTemplateGetAllcategories$Params } from '../fn/notes-template/notes-template-get-allcategories';
import { notesTemplatePost } from '../fn/notes-template/notes-template-post';
import { NotesTemplatePost$Params } from '../fn/notes-template/notes-template-post';
import { notesTemplatePut } from '../fn/notes-template/notes-template-put';
import { NotesTemplatePut$Params } from '../fn/notes-template/notes-template-put';

@Injectable({ providedIn: 'root' })
export class NotesTemplateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `notesTemplateFindNotesByCategory()` */
  static readonly NotesTemplateFindNotesByCategoryPath = '/api/NotesTemplate/category/{CategoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notesTemplateFindNotesByCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateFindNotesByCategory$Response(params: NotesTemplateFindNotesByCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfNotesTemplate>> {
    return notesTemplateFindNotesByCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notesTemplateFindNotesByCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateFindNotesByCategory(params: NotesTemplateFindNotesByCategory$Params, context?: HttpContext): Observable<DataPageOfNotesTemplate> {
    return this.notesTemplateFindNotesByCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfNotesTemplate>): DataPageOfNotesTemplate => r.body)
    );
  }

  /** Path part for operation `notesTemplateFindAll()` */
  static readonly NotesTemplateFindAllPath = '/api/NotesTemplate/findAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notesTemplateFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateFindAll$Response(params?: NotesTemplateFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfNotesTemplate>> {
    return notesTemplateFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notesTemplateFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateFindAll(params?: NotesTemplateFindAll$Params, context?: HttpContext): Observable<DataPageOfNotesTemplate> {
    return this.notesTemplateFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfNotesTemplate>): DataPageOfNotesTemplate => r.body)
    );
  }

  /** Path part for operation `notesTemplateFindTemplatesByCategory()` */
  static readonly NotesTemplateFindTemplatesByCategoryPath = '/api/NotesTemplate/note/{CategoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notesTemplateFindTemplatesByCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateFindTemplatesByCategory$Response(params: NotesTemplateFindTemplatesByCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NotesTemplate>>> {
    return notesTemplateFindTemplatesByCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notesTemplateFindTemplatesByCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateFindTemplatesByCategory(params: NotesTemplateFindTemplatesByCategory$Params, context?: HttpContext): Observable<Array<NotesTemplate>> {
    return this.notesTemplateFindTemplatesByCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NotesTemplate>>): Array<NotesTemplate> => r.body)
    );
  }

  /** Path part for operation `notesTemplateGet()` */
  static readonly NotesTemplateGetPath = '/api/NotesTemplate/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notesTemplateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateGet$Response(params: NotesTemplateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<NotesTemplate>> {
    return notesTemplateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notesTemplateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateGet(params: NotesTemplateGet$Params, context?: HttpContext): Observable<NotesTemplate> {
    return this.notesTemplateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotesTemplate>): NotesTemplate => r.body)
    );
  }

  /** Path part for operation `notesTemplatePut()` */
  static readonly NotesTemplatePutPath = '/api/NotesTemplate/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notesTemplatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notesTemplatePut$Response(params: NotesTemplatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return notesTemplatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notesTemplatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notesTemplatePut(params: NotesTemplatePut$Params, context?: HttpContext): Observable<Blob> {
    return this.notesTemplatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `notesTemplateDelete()` */
  static readonly NotesTemplateDeletePath = '/api/NotesTemplate/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notesTemplateDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateDelete$Response(params: NotesTemplateDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return notesTemplateDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notesTemplateDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateDelete(params: NotesTemplateDelete$Params, context?: HttpContext): Observable<Blob> {
    return this.notesTemplateDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `notesTemplatePost()` */
  static readonly NotesTemplatePostPath = '/api/NotesTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notesTemplatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notesTemplatePost$Response(params: NotesTemplatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return notesTemplatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notesTemplatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notesTemplatePost(params: NotesTemplatePost$Params, context?: HttpContext): Observable<Blob> {
    return this.notesTemplatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `notesTemplateGetAllcategories()` */
  static readonly NotesTemplateGetAllcategoriesPath = '/notes/getallcategories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notesTemplateGetAllcategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateGetAllcategories$Response(params?: NotesTemplateGetAllcategories$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Category>>> {
    return notesTemplateGetAllcategories(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notesTemplateGetAllcategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateGetAllcategories(params?: NotesTemplateGetAllcategories$Params, context?: HttpContext): Observable<Array<Category>> {
    return this.notesTemplateGetAllcategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Category>>): Array<Category> => r.body)
    );
  }

  /** Path part for operation `notesTemplateAddPatientNotes()` */
  static readonly NotesTemplateAddPatientNotesPath = '/notes/addNotes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notesTemplateAddPatientNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateAddPatientNotes$Response(params?: NotesTemplateAddPatientNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<Note>> {
    return notesTemplateAddPatientNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notesTemplateAddPatientNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notesTemplateAddPatientNotes(params?: NotesTemplateAddPatientNotes$Params, context?: HttpContext): Observable<Note> {
    return this.notesTemplateAddPatientNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Note>): Note => r.body)
    );
  }

  /** Path part for operation `notesTemplateCreatePdf()` */
  static readonly NotesTemplateCreatePdfPath = '/patient{patientId}/notes/CreatePdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notesTemplateCreatePdf()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notesTemplateCreatePdf$Response(params: NotesTemplateCreatePdf$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
    return notesTemplateCreatePdf(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notesTemplateCreatePdf$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notesTemplateCreatePdf(params: NotesTemplateCreatePdf$Params, context?: HttpContext): Observable<ApiResponseOfString> {
    return this.notesTemplateCreatePdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOfString>): ApiResponseOfString => r.body)
    );
  }

}
